/**
 * Customer Cancelled List Component
 */
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import type { CustomerTrial } from '@/modules/Customer/types'
import { useCustomerTrialList } from '@/modules/Customer/hooks/use-customer-trial-list'

const Cancelled = () => {
    const {
        customers,
        pagination,
        stateComponent,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        serviceColumns,
        filterItems,
        handlePageChange,
        handlePageSizeChange,
        handleSortChange,
        getCustomerServices,
        hasServices,
        t,
    } = useCustomerTrialList('cancelled')

    return (
        <Paper className="space-y-2 my-2">
            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
            />
            {stateComponent || (
                <DataTableCustomized<CustomerTrial>
                    columns={columns}
                    rows={customers}
                    rowKey={(row) => row.customer_id}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search_customers'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'customer-cancelled-list',
                        },
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                    expandable={{
                        expandedColumns: serviceColumns,
                        expandedRowData: getCustomerServices,
                        expandedRowKey: (service) => String(service.service_id),
                        rowExpandable: hasServices,
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                />
            )}
        </Paper>
    )
}

export default Cancelled
